export const LETTER_STEPS = [
  {
    id: 'recipient',
    title: 'Recipient',
    hint: 'Who should receive this letter?',
    fields: [
      { key: 'date', label: 'Date' },
      { key: 'recipient_name', label: "Consultant / Recipient name" },
      { key: 'recipient_title', label: 'Department / title' },
      { key: 'recipient_facility', label: 'Hospital / clinic' },
      { key: 'recipient_address', label: 'Address / city' },
      { key: 'salutation', label: 'Salutation' },
    ],
  },
  {
    id: 'clinical',
    title: 'Clinical',
    hint: 'Patient story and clinical findings',
    fields: [
      { key: 'introduction', label: 'Introduction', multiline: true },
      { key: 'clinical_summary', label: 'Clinical summary', multiline: true },
      { key: 'diagnosis', label: 'Working diagnosis', multiline: true },
      { key: 'investigations_summary', label: 'Investigations', multiline: true },
      { key: 'treatment_given', label: 'Treatment given at campus', multiline: true },
    ],
  },
  {
    id: 'referral',
    title: 'Referral',
    hint: 'Why you are referring and how you close',
    fields: [
      { key: 'reason_for_referral', label: 'Reason for referral', multiline: true },
      { key: 'closing', label: 'Closing', multiline: true },
    ],
  },
  {
    id: 'signatory',
    title: 'Signatory',
    hint: 'Printed name under the signature block',
    fields: [
      { key: 'doctor_signature_name', label: 'Doctor name' },
      { key: 'doctor_designation', label: 'Designation' },
      { key: 'facility_name', label: 'Issuing facility' },
    ],
  },
];

export const LETTER_FIELDS = LETTER_STEPS.flatMap((s) => s.fields);

export const STATUS_META = {
  submitted: { label: 'With doctor', cls: 'bg-sky-50 text-sky-800 border-sky-200' },
  pending_fic: { label: 'Awaiting approval', cls: 'bg-amber-50 text-amber-900 border-amber-200' },
  under_review: { label: 'Under Review', cls: 'bg-indigo-50 text-indigo-800 border-indigo-200' },
  letter_draft: { label: 'Letter Draft', cls: 'bg-violet-50 text-violet-800 border-violet-200' },
  issued: { label: 'Issued', cls: 'bg-emerald-50 text-emerald-800 border-emerald-200' },
  rejected: { label: 'Rejected', cls: 'bg-rose-50 text-rose-800 border-rose-200' },
  cancelled: { label: 'Cancelled', cls: 'bg-slate-50 text-slate-700 border-slate-200' },
};
